import React from "react"

export type CtxType = {
  activeData: any
  showDetails: boolean
  setActiveData: Function
  setShowDetails: Function
}

export const Context = React.createContext<Partial<CtxType>>({})
